import React, { Suspense } from 'react'

import { Route, Switch } from 'react-router-dom'

import { LayoutSplashScreen } from '_metronic'

import { ISLAS_CUADRESCOMBUSTIBLES, ISLAS_CONTROL } from 'constants/codigosTransacciones'

import ControlPage from './control'
import CuadresCombustiblesPage from './cuadresCombustibles'

export default function IslasPages() {
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Switch>
        <Route path={`/${ISLAS_CUADRESCOMBUSTIBLES}`} component={CuadresCombustiblesPage} />
        <Route path={`/${ISLAS_CONTROL}`} component={ControlPage} />
      </Switch>
    </Suspense>
  )
}
